var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveCardIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6576 18.6588C11.0089 18.3283 10.2867 18.1569 9.55226 18.1569C3.82373 18.5608 3.82373 26.8966 9.55226 27.3005H23.1269C24.7794 27.3128 26.3707 26.7007 27.5825 25.5869C31.6096 22.0738 29.4552 15.0111 24.1551 14.3379C22.2456 2.86856 5.68427 7.22617 9.61346 18.1569",
    fill: "url(#paint0_linear_1197_11030)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bi_1197_11030)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.62109,
    y: 22.2954,
    width: 27.3576,
    height: 7.95858,
    rx: 2.48706,
    fill: "url(#paint1_linear_1197_11030)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.68941,
    y: 22.3637,
    width: 27.221,
    height: 7.82195,
    rx: 2.41874,
    stroke: "white",
    strokeWidth: 0.136638
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 25.5415L12.3333 27.2495",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 27.2495L12.3333 25.5415",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8555 24.6873L10.8555 28.1032",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 25.5415L18.7083 27.2495",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 27.2493L18.7083 25.5413",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2305 24.6873L17.2305 28.1032",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.123 25.5415L25.0813 27.2495",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.123 27.2493L25.0813 25.5413",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6035 24.6873L23.6035 28.1032",
    stroke: "white",
    strokeWidth: 0.800295,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_1197_11030",
    x: 2.25472,
    y: 20.929,
    width: 30.0902,
    height: 10.6913,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.683189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1197_11030"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1197_11030",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.683189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_1197_11030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1197_11030",
    x1: 16.3907,
    y1: 7.57422,
    x2: 25.5465,
    y2: 32.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#388DF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1197_11030",
    x1: 5.2246,
    y1: 22.9126,
    x2: 17.2999,
    y2: 30.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A8BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C183FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveCardIcon12);
export default __webpack_public_path__ + "static/media/drive_card_icon12.f37719d294f70c25ae28151538e3f829.svg";
export { ForwardRef as ReactComponent };